const ru = {
  loadingTypes: {
    notSpecified: 'не указан',
  },
};

export { ru };
